import React from "react";
import "./index.scss";
const Tags = ({tags}) => {
	return (
		<>
			<div className="tags">
				<h2>Tags</h2>
				<div className="items">
				{
					tags?.map((i) => {
						return <button key={i._id} className="btn btn-link">{i.name}</button>
					})
				}
					
				</div>
			</div>
		</>
	);

}

export default Tags;